import { Pipe, PipeTransform } from '@angular/core';

/** Display-only label for permission module keys (e.g. Brooklyn.Projections → Projections). */
@Pipe({
  name: 'moduleDisplayName',
  standalone: false,
})
export class ModuleDisplayNamePipe implements PipeTransform {
  private static readonly BrooklynPrefix = 'Brooklyn.';
  private static readonly Labels: Record<string, string> = {
    'Brooklyn.Projections.Forecast': 'Forecast',
    'Brooklyn.Projections.Goal': 'Goal',
    'Brooklyn.Projections.Report': 'Report',
    RetailProgram: 'Retail Programs',
    'Brooklyn.RetailProgram': 'Retail Programs',
  };

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    const mapped = ModuleDisplayNamePipe.Labels[value];
    if (mapped) {
      return mapped;
    }

    let label = value;
    if (label.startsWith(ModuleDisplayNamePipe.BrooklynPrefix)) {
      label = label.substring(ModuleDisplayNamePipe.BrooklynPrefix.length);
    }

    return label.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  }
}
